import { Control, ScaleLine } from "ol/control";

export class ScaleControl extends Control {
    constructor() {
        super({ element: undefined });
        return new ScaleLine({ className: "ol-scale-line scale-container ol-control" });
    }
}
